import React, { useCallback, useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    FormControlLabel,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiRequest, BASE_URL } from '../../utils/api';
import Loader from '../../components/Loader';
import ErrorScreen from '../../components/ErrorScreen';
import { exportOrderDetailToExcel, exportToExcel } from '../../utils/exportToExcel';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductData } from '../../redux/slices/productSlice';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import ModalCustom from '../../components/modals/ModalCustom';
import { useReactToPrint } from 'react-to-print';
import OrderDetailPrint from '../../print/OrderDetailPrint';

export default function OrderDetail() {
    let { user } = useSelector((state) => state?.user);
    let { state } = useLocation();
    const navigate = useNavigate();
    let { orderId } = useParams();
    const dispatch = useDispatch();
    const fieldProductRef = useRef(null);
    const { data: products } = useSelector((state) => state.product);

    const [order, setOrder] = useState(state || {});

    const [productList, setProductList] = useState(null);
    const [deletedItemIds, setDeletedItemIds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [loadReq, setLoadReq] = useState(false);

    const commentRef = useRef(order?.comments);
    const messageRef = useRef(order?.message);

    // const [comments, setComments] = useState(order?.comments);
    // const [message, setMessage] = useState(order?.message);
    const [orderCreatedOn, setOrderCreatedOn] = useState(order?.createdOn);
    const [sumOfQtyOrder, setSumOfQtyOrder] = useState(0);
    const [sumOfQtyDispatch, setSumOfQtyDispatch] = useState(0);

    const [selectedProduct, setSelectedProduct] = useState({});
    const [qtyOrder, setQtyOrder] = useState(0);

    const [selectedStatus, setSelectedStatus] = useState(order?.status);
    const [dispatchDate, setDispatchDate] = useState('');
    const [vehicleArrive, setVehicleArrive] = useState(false);
    const [goodsList, setGoodsList] = useState([]);
    const [selectedGoods, setSelectedGoods] = useState([]);
    const handleStatus = useCallback((e) => {
        const nextStatus = e?.target?.value;
        setSelectedStatus(nextStatus);
        if (nextStatus === 'Dispatched' && !dispatchDate) {
            setDispatchDate(moment().format('YYYY-MM-DD'));
        }
    }, [dispatchDate]);

    // Print functionality
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => printRef.current
    });

    const handleqtyOrderChange = (index, value) => {
        const newData = [...productList];
        newData[index].qtyOrder = value; //Math.max(0, parseInt(value) || 0);
        const sumQtyOrder = newData.reduce((total, item) => total + parseInt(item.qtyOrder?.replace(/\D/g, '') || 0), 0);
        setSumOfQtyOrder(sumQtyOrder);
        setProductList(newData);
    };

    const handleQtyDispatchChange = (index, value) => {
        const newData = [...productList];
        newData[index].qtyDispatch = value; //Math.max(0, Math.min(newData[index].qtyOrder, parseInt(value) || 0));
        const sumQtyDispatch = newData.reduce((total, item) => total + parseInt(item.qtyDispatch?.replace(/\D/g, '') || 0), 0);
        setSumOfQtyDispatch(sumQtyDispatch);
        setProductList(newData);
    };

    const handleSave = async () => {
        setLoadReq(true);
        try {
            if (selectedStatus == null) {
                return toast.error('Please select status');
            }

            // let filterProductList = productList?.filter((i) => i?.qtyOrder !== 0);
            if (productList?.length == 0) {
                return toast.error('Please update atleast one product');
            }
            if (selectedStatus === 'Dispatched' && !dispatchDate) {
                return toast.error('Please select dispatch date');
            }

            let fineList = productList?.map((i) => ({
                id: i?.id,
                product: i?.product?.id,
                qtyOrder: i?.qtyOrder,
                qtyDispatch: i?.qtyDispatch
            }));

            let responseInvoice = null;
            if (invoiceFile?.image) {
                const token = JSON.parse(localStorage.getItem('token'));
                let formdata = new FormData();
                formdata.append('file', invoiceFile?.image, invoiceFile?.name);
                responseInvoice = await axios({
                    method: 'post',
                    url: `${BASE_URL}orders/upload-invoice`,
                    data: formdata,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            let data = {
                user: order?.user?._id,
                customer: order?.customer?._id,
                orderItems: fineList,
                comments: commentRef?.current.value,
                message: messageRef?.current.value,
                status: selectedStatus,
                dispatchInvoiceImg: responseInvoice?.data?.invoiceURL || null,
                createdOn: new Date(orderCreatedOn) || new Date(order?.createdOn),
                ...(selectedStatus === 'Dispatched' && {
                    dispatchDate: moment(dispatchDate, 'YYYY-MM-DD').endOf('day').toISOString()
                }),
                ...(selectedStatus === 'Ready for Dispatch' && {
                    vehicleArrive,
                    goods: selectedGoods
                }),
                deletedItemIds
            };
            const res = await apiRequest('put', `orders/${orderId}`, data);

            if (res?.data) {
                await getOrderDetails();
                return toast.success('Order updated successfully');
            }
        } catch (error) {
            return toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoadReq(false);
        }
    };

    const getOrderDetails = async () => {
        try {
            setLoading(true);

            const [orderResponse, orderProductsRes] = await Promise.all([
                await apiRequest('get', `orders/${orderId}`),
                await apiRequest('get', `orders/items/${orderId}`)
            ]);

            try {
                const goodsResponse = await apiRequest('get', 'goods');
                setGoodsList(goodsResponse?.data || []);
            } catch (error) {
                setGoodsList([]);
            }

            if (orderResponse) {
                commentRef.current = orderResponse?.data?.comments;
                messageRef.current = orderResponse?.data?.message;
                // setMessage(orderResponse?.data?.message);
                // setComments(orderResponse?.data?.comments);
                setOrderCreatedOn(orderResponse?.data?.createdOn);
                setSelectedStatus(orderResponse?.data?.status);
                setDispatchDate(
                    orderResponse?.data?.dispatchDate ? moment(orderResponse?.data?.dispatchDate).format('YYYY-MM-DD') : ''
                );
                setVehicleArrive(orderResponse?.data?.vehicleArrive || false);
                setSelectedGoods(orderResponse?.data?.goods?.map((item) => item?.id || item?._id) || []);
                setOrder(orderResponse?.data);
            }
            if (orderProductsRes) {
                const sumQtyOrder = orderProductsRes?.data?.reduce(
                    (total, item) => total + parseInt(item.qtyOrder?.replace(/\D/g, '') || 0),
                    0
                );
                const sumQtyDispatch = orderProductsRes?.data?.reduce(
                    (total, item) => total + parseInt(item.qtyDispatch?.replace(/\D/g, '') || 0),
                    0
                );
                setProductList(orderProductsRes?.data);
                setSumOfQtyDispatch(sumQtyDispatch);
                setSumOfQtyOrder(sumQtyOrder);
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getOrderDetails();

        if (!products) {
            dispatch(fetchProductData());
        }

        return () => {
            setError(null);
            setLoading(true);
            setProductList(null);
        };
    }, []);

    const handleExport = async () => {
        try {
            const transformedData = productList.map((item) => ({
                Product_Name: item?.product?.name,
                Qty_Order: item?.qtyOrder,
                Qty_Dispatch: item?.qtyDispatch
            }));

            let data = {
                Id: order?.serialNo,
                Rep: `${order?.user?.firstName} ${order?.user?.lastName}`,
                Customer: `${order?.customer?.name}`,
                Status: order?.status,
                TotalProducts: order?.totalProducts,
                Comments: order?.comments,
                Message: order?.message,
                CreatedOn: moment(order?.createdOn).format('MMM DD, YYYY - hh:mm A'),
                productList: [
                    ...transformedData,
                    {
                        Product_Name: 'Total',
                        Qty_Order: sumOfQtyOrder,
                        Qty_Dispatch: sumOfQtyDispatch
                    }
                ]
            };
            if (!!productList) {
                exportOrderDetailToExcel(data, `${order?.serialNo}-${order?.user?.firstName}_${order?.user?.lastName}.xlsx`);
            }
        } catch (error) {
            return toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        }
    };

    const handleAddProduct = () => {
        if (selectedProduct?.id == null) {
            return toast.error('Please select any product to add');
        }
        if (qtyOrder < 1) {
            return toast.error('Quantity Order should be atleast 1');
        }

        let newProduct = {
            id: productList?.length + 1,
            product: {
                id: selectedProduct?.id,
                name: selectedProduct?.name
            },
            qtyOrder,
            qtyDispatch: '0'
        };

        const newData = [...productList, newProduct];
        const sumQtyOrder = newData.reduce((total, item) => total + parseInt(item.qtyOrder?.replace(/\D/g, '') || 0), 0);
        setSumOfQtyOrder(sumQtyOrder);
        setProductList(newData);
        setSelectedProduct({});
        setQtyOrder(1);
        fieldProductRef.current.focus();
    };

    const handleDelete = (id) => {
        const newList = productList?.filter((i) => i?.id !== id);
        const sumQtyOrder = newList.reduce((total, item) => total + parseInt(item.qtyOrder?.replace(/\D/g, '') || 0), 0);
        setSumOfQtyOrder(sumQtyOrder);
        setProductList(newList);
        setDeletedItemIds((pre) => [...pre, id]);
    };

    //-----
    const [enableEdit, setEnableEdit] = useState(false);
    const handleEnableEdit = (e) => {
        setEnableEdit(e.target.checked);
    };

    const [showInvoice, setShowInvoice] = useState(false);
    const [invoiceFile, setInvoiceFile] = useState(null);

    const handleUploadInvoice = async (file) => {
        let imageName = file?.[0]?.name;

        let image = {
            name: imageName,
            image: file?.[0],
            url: URL.createObjectURL(file?.[0])
        };

        setInvoiceFile(image);
    };

    return (
        <Layout>
            {loading && <Loader />}
            {!!error && <ErrorScreen error={error} />}
            {!!order && !loading && (
                <>
                    <Grid container spacing={2}>
                        <Grid item lg={10.5}>
                            <Grid container spacing={1} sx={{ backgroundColor: '#FFF', borderRadius: 1, p: 1, mt: 0.1 }}>
                                <Grid item lg={1.5}>
                                    <Typography>ID</Typography>
                                </Grid>

                                <Grid item lg={2.5}>
                                    <Typography variant="subtitle2">{order?.serialNo}</Typography>
                                </Grid>

                                <Grid item lg={1.5}>
                                    <Typography>Created Date</Typography>
                                </Grid>

                                <Grid item lg={2.5}>
                                    {user?.role == 'admin' && user?.name == 'Imran Saleem' ? (
                                        <TextField
                                            size="small"
                                            type="datetime-local"
                                            variant="standard"
                                            value={moment(orderCreatedOn).format('YYYY-MM-DDTHH:mm')}
                                            onChange={(e) => setOrderCreatedOn(e.target.value)}
                                        />
                                    ) : (
                                        <Typography variant="subtitle2">
                                            {moment(order?.createdOn).format('MMM DD, YYYY - hh:mm A')}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item lg={1.5}>
                                    <Typography>Rep Name</Typography>
                                </Grid>

                                <Grid item lg={2.5}>
                                    <Typography variant="subtitle2">
                                        {order?.user?.firstName} {order?.user?.lastName}
                                    </Typography>
                                </Grid>
                                <Grid item lg={1.5}>
                                    <Typography>Customer Name</Typography>
                                </Grid>
                                <Grid item lg={3.5}>
                                    <Typography variant="subtitle2">
                                        {order?.customer?.name} ({order?.customer?.phoneNo}
                                        {order?.customer?.phoneNo2 ? `, ${order?.customer?.phoneNo2}` : ''})
                                    </Typography>
                                </Grid>

                                <Grid item lg={1.5}>
                                    <Typography>Total Products</Typography>
                                </Grid>

                                <Grid item lg={1.5}>
                                    <Typography variant="subtitle2">{order?.totalProducts}</Typography>
                                </Grid>
                                <Grid item lg={1.5}>
                                    <Typography>Status</Typography>
                                </Grid>
                                <Grid item lg={2.5}>
                                    <Typography variant="subtitle2">{order?.status}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item lg={1.5}>
                            <Grid container spacing={1}>
                                <Grid item lg={12}>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedStatus}
                                            label="Status"
                                            onChange={(e) => handleStatus(e)}
                                        >
                                            <MenuItem value={'Order Placed'}>Order Placed</MenuItem>
                                            <MenuItem value={'In Process'}>In Process</MenuItem>
                                            <MenuItem value={'Hold'}>Hold</MenuItem>
                                            <MenuItem value={'Order Approved'}>Order Approved</MenuItem>
                                            <MenuItem value={'Ready for Dispatch'}>Ready for Dispatch</MenuItem>
                                            <MenuItem value={'Dispatched'}>Dispatched</MenuItem>
                                            <MenuItem value={'Cancelled'}>Cancelled</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item lg={12}>
                                    <Button onClick={handleSave} size="small" fullWidth variant="contained">
                                        Save
                                    </Button>
                                </Grid>
                                <Grid item lg={12}>
                                    <Button onClick={handlePrint} size="small" fullWidth variant="contained" color="success">
                                        Print
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {enableEdit && (
                            <>
                                <Grid item lg={2.5} sm={5} md={3} xs={12}>
                                    <Autocomplete
                                        size="small"
                                        options={products ?? []}
                                        getOptionLabel={(prod) => `${prod?.name} - ${prod?.packing}`}
                                        value={products?.find((i) => i?.id == selectedProduct?.id) || null}
                                        onChange={(event, selected) => {
                                            setSelectedProduct(selected);
                                        }}
                                        renderInput={(params) => (
                                            <TextField inputRef={fieldProductRef} {...params} label="Product" variant="outlined" />
                                        )}
                                    />
                                </Grid>

                                <Grid item lg={1} sm={5} md={3} xs={4}>
                                    <TextField
                                        size="small"
                                        value={qtyOrder}
                                        onChange={(e) => setQtyOrder(e?.target?.value)}
                                        fullWidth
                                        label={'Quantity Order'}
                                    />
                                </Grid>

                                <Grid item lg={1} sm={5} md={3} xs={4}>
                                    <Button onClick={handleAddProduct} variant="contained" fullWidth>
                                        Add
                                    </Button>
                                </Grid>
                            </>
                        )}

                        <Grid item lg={enableEdit ? 5.5 : 10}>
                            <TextField
                                defaultValue={commentRef.current}
                                inputRef={commentRef}
                                fullWidth
                                size="small"
                                label="Comments"
                                // value={comments}
                                // onChange={(e) => setComments(e?.target?.value)}
                            />
                        </Grid>
                        <Grid item lg={0.5}>
                            <Switch checked={enableEdit} onChange={handleEnableEdit} inputProps={{ 'aria-label': 'controlled' }} />
                        </Grid>
                        <Grid item lg={1.5}>
                            <Button onClick={handleExport}>Export to Excel</Button>
                        </Grid>

                        <Grid item lg={10}>
                            <TextField
                                defaultValue={messageRef.current}
                                inputRef={messageRef}
                                fullWidth
                                size="small"
                                label="Message"
                                // value={message}
                                // onChange={(e) => setMessage(e?.target?.value)}
                            />
                        </Grid>

                        {selectedStatus == 'Dispatched' && (
                            <Grid item lg={2}>
                                <TextField
                                    size="small"
                                    label="Dispatch Date"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={dispatchDate}
                                    onChange={(e) => setDispatchDate(e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                        )}

                        {selectedStatus == 'Ready for Dispatch' && (
                            <>
                                <Grid item lg={2.5}>
                                    <FormControlLabel
                                        control={<Checkbox checked={vehicleArrive} onChange={(e) => setVehicleArrive(e.target.checked)} />}
                                        label="Vehicle Arrive"
                                    />
                                </Grid>
                                <Grid item lg={3.5}>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="goods-select-label">Goods</InputLabel>
                                        <Select
                                            labelId="goods-select-label"
                                            multiple
                                            value={selectedGoods}
                                            label="Goods"
                                            onChange={(e) => setSelectedGoods(e.target.value)}
                                        >
                                            {goodsList?.map((good) => (
                                                <MenuItem key={good?.id} value={good?.id}>
                                                    {good?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {selectedStatus == 'Dispatched' && (
                            <Grid item lg={2}>
                                <TextField
                                    size="small"
                                    label="Upload Invoice"
                                    InputLabelProps={{ shrink: true }}
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleUploadInvoice(e.target.files)}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Product Name</TableCell>
                                    <TableCell>Packing</TableCell>
                                    <TableCell>Quantity Order</TableCell>
                                    <TableCell>
                                        Quantity Dispatch
                                        {order?.dispatchInvoiceImg && (
                                            <Chip onClick={() => setShowInvoice(true)} sx={{ float: 'right' }} label="Show Invoice" />
                                        )}
                                    </TableCell>
                                    {enableEdit && <TableCell width={50}></TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {productList?.map((row, index) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 }
                                        }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row?.product?.name}
                                        </TableCell>
                                        <TableCell>
                                            {row?.product?.packing || '-'}
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        height: '10px'
                                                    }
                                                }}
                                                size="small"
                                                value={row?.qtyOrder}
                                                onChange={(e) => handleqtyOrderChange(index, e.target.value)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        height: '10px'
                                                    }
                                                }}
                                                size="small"
                                                value={row?.qtyDispatch}
                                                onChange={(e) => handleQtyDispatchChange(index, e.target.value)}
                                            />
                                        </TableCell>
                                        {enableEdit && (
                                            <TableCell component="th" scope="row">
                                                <IconButton onClick={() => handleDelete(row?.id)} aria-label="Delete" size="small">
                                                    <DeleteIcon sx={{ color: 'red', fontSize: 15 }} />
                                                </IconButton>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                ))}

                                {!!productList && (
                                    <TableRow
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        <TableCell component="th" scope="row">
                                            Total
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>{sumOfQtyOrder}</TableCell>
                                        <TableCell>{sumOfQtyDispatch}</TableCell>
                                        {enableEdit && <TableCell></TableCell>}
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}

            <ModalCustom open={showInvoice}>
                <IconButton
                    color="inherit"
                    onClick={() => setShowInvoice(false)}
                    sx={{ position: 'absolute', top: 8, right: 5, backgroundColor: '#fff' }}
                >
                    <CloseIcon />
                </IconButton>
                <Box sx={{ ml: -2.1, mr: -2.7, mb: -1.7, mt: -3.2 }}>
                    <img src={order?.dispatchInvoiceImg} alt={'Dispatched Invoice Image'} width={'100%'} />
                </Box>
            </ModalCustom>

            {/* Hidden Print Component */}
            <div style={{ display: 'none' }}>
                <OrderDetailPrint
                    ref={printRef}
                    order={order}
                    productList={productList}
                    comments={commentRef?.current?.value}
                    message={messageRef?.current?.value}
                />
            </div>
        </Layout>
    );
}
